import { render } from "./list.vue?vue&type=template&id=f3be06f4&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=f3be06f4&lang=css"
import "./list.vue?vue&type=style&index=1&id=f3be06f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3be06f4"]])

export default __exports__